//Dependencies
import React from "react"
import SvgIcon from "../../../../hooks/svg"
import RenderLink from "../../../ui/link/link"

//Styles
import "./mobile-info-links.scss"

//Hooks

const MobileInfoLinks = props => {
  const componentProps = props.blok
    ? props.blok
    : props.props
    ? props.props
    : props

  return (
    <div className="mobile-info-links">
      <div className="mobile-info-links__content">
        <RenderLink
          className="mobile-info-links__content-text"
          linkText={componentProps.linkText}
          linkUrl={componentProps.link.url || "#"}
        />
        <SvgIcon height="12" name={"arrow-right-m"} />
      </div>
    </div>
  )
}

export default MobileInfoLinks
